import { BREAKPOINTS } from './breakpoints'

export const MEDIA_QUERIES = {
  sm: `(min-width: ${BREAKPOINTS.sm.min}${BREAKPOINTS.sm.uom}) and (max-width: ${BREAKPOINTS.sm.max}${BREAKPOINTS.sm.uom})`,
  md: `(min-width: ${BREAKPOINTS.md.min}${BREAKPOINTS.md.uom}) and (max-width: ${BREAKPOINTS.md.max}${BREAKPOINTS.md.uom})`,
  lg: `(min-width: ${BREAKPOINTS.lg.min}${BREAKPOINTS.lg.uom})`
} as const
